<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AvUna/tc-custom/9781788853606.jpg?1718106503981" alt="This image is the cover for the book Beatons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beatons
      </h1>
      <p class="bookDescription body article font2">
        <p>This book traces the Clann Meic-bethad or Clan MacBeth whose members practised medicine in the classic Gaelic tradition in various parts of Scotland from the early fourteenth to the early eighteenth century. From many medieval Gaelic manuscripts known to have been in their possession, individual members of the clan and their activities are identified. Sometime in the second half of the sixteenth century the kindred began to adopt Beaton as a surname for use in non-Gaelic contexts.  The medical Beatons fell naturally into two divisions: one confined mainly to the Western Isles and the other to the mainland of Scotland. This detailed study of the Beatons and their medicine describes how the position of medical doctor was inherited by the eldest son, and potential Beaton physicians were sent out to be trained by other members of the family for several years before undertaking their own practice. The book provides information on medieval medicine at the highest levels of Highland society.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Bannerman
      </h2>
      
      <p class="authorDescription body article">John Bannerman studied Celtic languages at the University of Glasgow and gained a PhD from the University of Cambridge. He joined the history department at Edinburgh University in 1967 and worked there for 30 years, while also running the family farm at Balmaha, Stirlingshire. He published a number of influential works on Gaelic Scotland, including Studies in the History of Dalriada and a major contribution to Late Medieval Monumental Sculpture in the West Highlands. He retired from teaching in 1997 and took up farming full-time at Balmaha. He died in 2008.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Birlinn Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1950fb51